import { createSelector } from 'reselect';
import { LoyaltyOfferStatus } from '../type';
import { LoyaltyState } from './loyalty.slice';

const loyaltiesSelector = (state: { loyaltiesApp: LoyaltyState }) => state.loyaltiesApp || {};

export const loyaltyModelSelector = createSelector(loyaltiesSelector, loyalties => loyalties.entity);

export const loyaltyOffersSelector = createSelector(loyaltiesSelector, loyalties => loyalties.entity?.loyaltyOffers);

export const archivedLoyaltyOffersSelector = createSelector(loyaltiesSelector, loyalties =>
  loyalties.entity?.loyaltyOffers
    ?.filter(offer => offer.status === LoyaltyOfferStatus.ARCHIVED)
    .sort((a, b) => a.redeemPointAmount - b.redeemPointAmount),
);

export const activeLoyaltyOffersSelector = createSelector(loyaltiesSelector, loyalties =>
  loyalties.entity?.loyaltyOffers
    ?.filter(offer => offer.status === LoyaltyOfferStatus.ACTIVE)
    .sort((a, b) => a.redeemPointAmount - b.redeemPointAmount),
);

export const loyaltyDialogSelector = createSelector(loyaltiesSelector, loyalties => loyalties.loyaltyDialog);

export const areLoyaltiesLoading = createSelector(loyaltiesSelector, loyalties => loyalties.isLoading);
export const areLoyaltyOffersLoadingSelector = createSelector(
  loyaltiesSelector,
  loyalties => loyalties.isOffersLoading,
);

export const loyaltiesConfirmDialogSelector = createSelector(
  loyaltiesSelector,
  loyalties => loyalties.confirmDeleteDialog,
);

export const loyaltyProductListSelector = createSelector(
  loyaltiesSelector,
  loyalties => loyalties.entity?.selectedProductList ?? [],
);

export const loyaltyExtrasListSelector = createSelector(
  loyaltiesSelector,
  loyalties => loyalties.entity?.selectedExtrasList ?? [],
);
